import Card from "@digital-hig/mui/Card";
import Button from "@digital-hig/mui/Button";
import { Box, CardContent, Divider, Link } from "@mui/material";
import CardActions from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import { HOME_PAGE_CONTENT } from "@/constants/commonConstants";
import LinkButton from "@/components/common/LinkButton";
import SvgIcon from "@digital-hig/mui/SvgIcon";
import { CtaArrowRight } from "@digital-hig/icon";

const Home = () => {
  const { tiles, description } = HOME_PAGE_CONTENT;
  // const [showJobForm, setShowJobForm] = useState(false);

  return (
    <>
      <div className="home-page content" style={{ marginBottom: 50 }}>
        <Box display="grid" gap={7} sx={{ marginTop: "1%" }}>
          <Box>
            <Typography variant="body2">{description} </Typography>
          </Box>
          <Box display="flex" justifyContent="flex-end" gap={4} sx={{ marginBottom: "1%" }}>
            <LinkButton href="/submitjob">Get Started</LinkButton>
          </Box>
        </Box>
        <Divider sx={{ marginBottom: "2.4%" }} />
        <Box style={{ width: "100%" }} display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={7} columnGap={7}>
          {tiles?.map((tile, index) => {
            return (
              <Box gridColumn="span 3" key={index}>
                <Card>
                  <CardContent sx={{ minHeight: "165px", maxHeight: "165px" }}>
                    <Typography gutterBottom variant="h6" component="div" sx={{ fontWeight: "bold" }}>
                      {tile.title}
                    </Typography>
                    <Typography variant="body2" fontSize={13}>
                      {tile.text}
                    </Typography>
                  </CardContent>

                  <Box padding={6}>
                    <Divider sx={{ marginBottom: "1%" }} />
                  </Box>
                  <CardActions sx={{ flexDirection: "row-reverse" }}>
                    <Button
                      href={tile.link}
                      target="_blank"
                      startIcon={
                        <SvgIcon fontSize="medium">
                          <CtaArrowRight />
                        </SvgIcon>
                      }
                      variant="link-button"
                    >
                      Learn more
                    </Button>
                  </CardActions>
                </Card>
              </Box>
            );
          })}
        </Box>
      </div>
    </>
  );
};

export default Home;
